import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { HeroSectionSplit as HeroSection } from '../components/HeroSectionSplit';
import { RoomGallery } from '../components/RoomGallery';
import { Amenities } from '../components/Amenities';
import { Location } from '../components/Location';
import { Testimonials } from '../components/Testimonials';
import { Policies } from '../components/Policies';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { AdminApp } from '../components/admin/AdminApp';

function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Header />
      <main className="overflow-x-hidden">
        <HeroSection />
        <RoomGallery />
        <Amenities />
        <Location />
        <Testimonials />
        <Policies />
        <Contact />
      </main>
      <Footer />
      
      {/* Luxury Admin Access - Press Ctrl+Shift+A */}
      <div
        className="fixed bottom-6 right-6 opacity-0 hover:opacity-100 transition-opacity duration-300"
        onKeyDown={(e) => {
          if (e.ctrlKey && e.shiftKey && e.key === 'A') {
            navigate('/admin');
          }
        }}
        tabIndex={-1}
      >
        <button
          onClick={() => navigate('/admin')}
          className="bg-gold-gradient text-navy-900 px-6 py-3 rounded-2xl text-sm hover:shadow-gold-xl transition-all duration-300 transform hover:scale-105 font-bold shadow-luxury"
          title="Luxury Admin Access (Ctrl+Shift+A)"
        >
          🏨 Admin Portal
        </button>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin/*" element={<AdminApp />} />
      </Routes>
    </Router>
  );
}

export default App;